import { Paper } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useEffect } from "react";

export default function EchoAlert(props) {
  const { type, value, echoAlert, setEchoAlert, result, setPingStatus} = props;

  const [open, setOpen] = React.useState(false);
  const StyledPaper = styled(Paper)`
  background-color: #1a2c2b;
  color:rgb(249, 215, 161);
`;

  useEffect(() => {
    setOpen(echoAlert);
  }, [echoAlert]);

  const handleClose = () => {
    setOpen(false);
    setEchoAlert(false);
    setPingStatus(false);
  };

  return (
    <span>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="delte-alert"
        fullWidth
        PaperComponent={StyledPaper}
      >
        <DialogTitle>{"Verification Status"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(249, 215, 161)"}}>
            <p>{type} Verification:</p>
            {type == "PLATFORM" && <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
              <p style={{ marginRight: "10px" }}>{value}:</p>
              {result == "Ping Successful" && <p style={{ color: "#5d9d5d" }}>Connection Successful!</p>}
              {result == "Unable to Ping Platform" && <p style={{ color: "#f23f3f" }}>Failed</p>}
            </div>}
            {type == "C-ECHO" && (<div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
              <p style={{ marginRight: "10px" }}>{value}:</p>
              {result == "Connection Successfull!" && <p style={{ color: "#5d9d5d" }}>Connection Successful!</p>}
              {result == "Connection Failed." && <p style={{ color: "#f23f3f" }}>Failed</p>}
            </div>)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} style={{color: "#198754ff"}}>Close</Button>
        </DialogActions>
      </Dialog>
    </span>
  );
}
